"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.substringBetween = void 0;
function substringBetween(str, a, b) {
    const startIndex = str.indexOf(a) + a.length;
    return str.substring(startIndex, str.indexOf(b, startIndex));
}
exports.substringBetween = substringBetween;
